import { rem } from "@certn/cascadia";
import { CascadiaSpacing } from "@certn/cascadia-tokens";
import { css, cx } from "@emotion/css";
import { PropsWithChildren } from "react";
import { mergeProps } from "react-aria";

interface Props extends PropsWithChildren {
  padding?: CascadiaSpacing;
  testID?: string;
}

export function DialogContent(props: Props) {
  const { padding = "space-5" } = props;

  const className = cx(
    css(styles.dialogBody, { padding: rem(padding) }),
    "react-aria-DialogBody"
  );

  return <div {...mergeProps(props, { className })}>{props.children}</div>;
}

const styles = {
  dialogBody: css({
    flex: 1,
    overflow: "auto",
    position: "relative",
    borderRadius: "inherit",
  }),
};
